import { useEffect, useState } from "react";
import "primeicons/primeicons.css";
import "./Index.scss";
import { SEARCH_API_CONSTANTS } from "../../constants/search.constanst";
import TabList from "../../components/tabList/TabList";
import { useLocation, useNavigate, useSearchParams } from "react-router-dom";
import FilterList from "../../components/filterList/FilterList";
import { SearchItem } from "@Src/interface/SearchInterface";
import SearchResult from "./components/SearchResult/SearchResult";
import { Paginator, PaginatorPageChangeEvent } from 'primereact/paginator';
import { getData, postData } from "../../services/global.service";
import { APIEnv, APIStatus, APIStatusError } from "../../interface/baseInterfaces";
import { IndexName } from "../../constants/constants";
import RightComponent from "./components/RightComponent/RightComponent";
import NoResultFound from "./components/SearchResult/NoResultFound/NoResultFound";
import SearchResultShimmer from "./components/SearchResult/SearchResultShimmer/SearchResultShimmer";
import Sortist from "../../components/sortList/sortList";
import { ResearchListSortOrder, SortByOption } from "./constants/filters.constants";
import { getDataFromLocalStorage, searchLogData, setDataOnLocalStorage } from "../../utils/globalUtilities";
import { LocalStorageDataModel } from "../../constants/local-storage-data-model";
import AIChat from "./components/AIChat/AIChat";
import SubscribeNow from "./components/SearchResult/SubscribeNow/SubscribeNow";

// interfaces
interface TabItem {
  id: string[];
  name: string;
  count: number;
}
interface FilterItem {
  id: string;
  name: string;
  ordering: number;
}

interface SearchDataFilter {
  CategoryList: FilterItem[];
  DoctypeList: FilterItem[];
  ActList: FilterItem[];
  SectionList: FilterItem[];
  CourtList: FilterItem[];
  InfavourList: FilterItem[];
  BenchList: FilterItem[];
  YearList: FilterItem[];
  SubjectList: FilterItem[];
  GlobaltopiList: FilterItem[];
  TopicList: FilterItem[];
  LevelList: FilterItem[];
  SubgroupList: FilterItem[];
}

interface SearchData {
  itemarray: SearchItem[];
  totalCount: number;
  seachText: string;
  highlightText: string;
  didYouMean: string;
  showingResultsfor: string;
  searchInsteadfor: string;
  filter: SearchDataFilter;
}

export const SearchPageIndex = () => {
  const location = useLocation();
  const [queryParams] = useSearchParams();
  const [tabClick, setTabClick] = useState<string>("Search");
  const [selectedTab, setSelectedTab] = useState<TabItem | null>(null);
  const [searchData, setSearchData] = useState<any>({});
  const [planData, setPlanData] = useState<any>({});
  const [data, setData] = useState([]);
  const [pageNo, setPageNo] = useState<number>(1);
  const [pageSize, setPageSize] = useState<number>(20);
  const [searchQuery, setSearchQuery] = useState<string>('');
  const [loading, setLoading] = useState<boolean>(false);
  const [tabData, setTabData] = useState<{
    data: { tabList: TabItem[] };
  } | null>(null);
  const [showTabList,setShowTabList]= useState<boolean>(true);
  const [filters, setFilters] = useState<any>({});
  const [exsistingfilters, setExsistingfilters] = useState<any>({});
  const [quickInfo, setQuickInfo] = useState({});
  const [first, setFirst] = useState<number>(0);
  const [subjectText, setSubjectText] = useState<Array<string>>([]);
  const [subjectType, setSubjectType] = useState<string>('p');
  const [previousSearchQuery, setPreviousSearchQuery] = useState<string>('');
  const [selectedSortOption, setSelectedSortOption] = useState(SortByOption[0]);
  const [selectedSortOrder, setSelectedSortOrder] = useState(ResearchListSortOrder.DESC);
  const [advanceSearchData, setAdvanceSearchData] = useState<any>({});
  const [filerPreSelection, setFilerPreSelection] = useState<any>({});
  const [isSubscribed, setIsSubscribed] = useState<boolean>(true);
  const navigate = useNavigate();
  const [showFilter, setShowFilter] = useState<boolean>(true);
  const [subjectReset, setSubjectReset] = useState<boolean>(false);
  const getQueryParam = (param: string) => {
    const queryParams = new URLSearchParams(location.search);
    return queryParams.get(param);
  };

  const getAdvaceSearchData = () => {
    if (Object.keys(advanceSearchData)?.length) {
      let searchData = { ...advanceSearchData };
      let data: any = {};
      if (searchData.exactSearch) {
        data['exactSearch'] = JSON.stringify(searchData.exactSearch.trim());;
      }
      if (searchData.anyOfSearch) {
        data['AnyOfSearchQuery'] = searchData.anyOfSearch;
      } if (searchData.notIncludeSearch) {
        data['notIncludeSearch'] = searchData.notIncludeSearch;
      }
      return data;
    }
  }

  const body = {
    searchData: searchQuery || "",
    page: pageNo,
    pageSize: pageSize,
    filter: {},
    sortby: "relevance",
    sortorder: 1,
    isUroIncluded: true,
    tabFilter: {},
    advanceSearch: getAdvaceSearchData()
  };

  const handleTabClick = (name: string) => {
    setFilters({});
    setExsistingfilters({})
    setSelectedSortOption(SortByOption[0]);
    setSelectedSortOrder(ResearchListSortOrder.DESC)
    setSubjectText([]);
    setTabClick(name);
    setPageNo(1);
    setFirst(0);

    if (tabData && tabData.data && tabData.data.tabList) {
      const selectedTabData = tabData.data.tabList.find((tab: TabItem) => tab.name === name);
      if (selectedTabData) {
        setSelectedTab(selectedTabData);
      } else {
        setSelectedTab(null);
      }
    } else {
      setSelectedTab(null);
    }
    setFilerPreSelection({});
    setPageNo(1);
    setFirst(0);
  };

  const handleSearchTabClick = (item: TabItem | null) => {
    setFilters({});
    setExsistingfilters({})
    setFilerPreSelection({});
    setSelectedTab(item);
  };

  const formatNumber = (num: any) => {
    if (num < 10) {
      num = '0' + num
    }
    return num.toString();
  }

  const formatDate = (selectedDate: any) => {
    let selDate = new Date(selectedDate);
    let day = formatNumber(selDate.getDate());
    let month = formatNumber(selDate.getMonth() + 1);
    let year = formatNumber(selDate.getFullYear());

    let value = year + month + day;
    return value;
  }

  const getFiltersIds = (filterData: any, params: any = {}) => {
    let filterIds: any = {};
    
    filterData = {
      ...filterData,
      ...params,
    };

    if (Object.keys(filterData)?.length) {
      Object.keys(filterData).forEach((key: string) => {
        if (typeof filterData[key] == 'object' && filterData[key] !== null) {
          if (filterData[key] instanceof Date) {
            filterIds[key] = formatDate(filterData[key]);
          } else {
            if (filterData[key] instanceof Array) {
              filterIds[key] = filterData[key].map((item: any) => item.id);
            } else {
              filterIds[key] = filterData[key].name;
            }
          }
        } else {
          filterIds[key] = filterData[key];
        }
      });
    } else if (Object.keys(filerPreSelection)?.length) {
      filterIds = { ...filerPreSelection }
    }
    return filterIds;
  };
  const urlParams = new URLSearchParams(window.location.search);

  const fromDateParam = urlParams.get('fromDate');
  const toDateParam = urlParams.get('toDate');
  
  const extraParams: any = {};
  if (fromDateParam) extraParams.fromDate = fromDateParam;
  if (toDateParam) extraParams.toDate = toDateParam;
  

  const searchBody = {
    searchData: searchQuery || "",
    page: pageNo,
    pageSize: pageSize,
    filter: getFiltersIds(filters, extraParams),
    tabfilter: selectedTab
      ? { id: selectedTab.id, name: selectedTab.name }
      : {},
    sortby: selectedSortOption?.value,
    sortorder: selectedSortOrder,
    isUroIncluded: true,
    subjectType: subjectText?.length ? subjectType : '',
    subjectText: subjectText,
    advanceSearch: getAdvaceSearchData()
  };
  

  useEffect(() => {
    if (getQueryParam("searchData")) {

      setPageNo(1);
      setFirst(0);
      // write condiitions to have advance search by looking at object

      // notIncludeSearch.................................
      let Not_Include: any = getQueryParam("searchData");

      // Case 1: Minus (-) Case
      function extractMinusValue(variable1: any) {
        const match = variable1.match(/ -(\w+)/);
        return match ? match[1] : null;
      }
      let minusCase = extractMinusValue(Not_Include);

      if (minusCase && minusCase.length) {
        function extractMinusValueData(variable1: string) {
          let replacedValue = variable1.replace(/ -(\w+)/gi, '');
          return replacedValue
        }
        Not_Include = extractMinusValueData(Not_Include);
      }

      // Case 2: Double Quotes ("value")
      function extractDoubleQuotedValue(variable2: string) {
        const match = variable2.match(/"([^"]*)"/);
        return match ? `${match[1]}` : null;
      }
      let doubleQuotes = extractDoubleQuotedValue(Not_Include);

      if (doubleQuotes && doubleQuotes.length) {
        function extractDoubleQuotedValueData(variable1: string) {
          return variable1.replace(/"([^"]*)"/, '');

        }
        Not_Include = extractDoubleQuotedValueData(Not_Include);
      }

      // Case 3: or & OR & Or or oR
      function extractOrValues(variable3: string) {
        let matches = variable3.split(/\s+OR\s+/g);
        let textJoined = '';
        if (matches && matches.length > 1) {
          matches.forEach((element: string, i: number) => {
            element = element.replace(/^\w+\s/, '');
            textJoined = textJoined + ' ' + element;
          });
        }
        return textJoined;
      }
      let OrCase = extractOrValues(Not_Include);
      function extractOrValuesData(variable3: string) {
        let matches = variable3.split(/\s+OR\s+/g);
        if (matches && matches.length > 1) {
          matches.forEach((element: string, i: number) => {
            element = element.replace(/^\w+\s/, '');
            let replacedTobeElement = i < matches.length - 1 ? element + ' or' : element;
            const re = new RegExp(replacedTobeElement, "gi");
            variable3 = variable3.replace(re, '');
          });
        }
        return variable3;
      }
      Not_Include = extractOrValuesData(Not_Include);

      // Case 4: Plus (+)
      function extractPlusValues(variable4: string) {
        if (variable4 && variable4.length) {
          const matches = variable4.split(/\s+\+\s+/);
          if (matches && matches.length > 1) {
            const quotedMatches = matches.map(value => `${value}`);
            return quotedMatches.join(' ');
          }
          else {
            return null;
          }
        } else {
          return null;
        }
      }

      let addCase = extractPlusValues(Not_Include);
      if (addCase && addCase.length) {
        function extractPlusValuesData(variable4: string) {
          return variable4.replace(/(\w+)\s*\+\s*(\w+)/gi, '');
        }
        Not_Include = extractPlusValuesData(Not_Include);
      }
      // case 5 remaining values
      let newData = Not_Include

      if (newData) {
        Not_Include = Not_Include.replace(minusCase, "")

        Not_Include = Not_Include.replace(doubleQuotes, "")

        Not_Include = Not_Include.replace(OrCase, "")

        Not_Include = Not_Include.replace(addCase, "")
        newData = Not_Include
      }

      //.....................................................
      let searchText =
      {
        'searchData': Not_Include ? Not_Include.trim() : '',
        'searchText': getQueryParam("searchData"),
        'notIncludeSearch': minusCase,
        'exactSearch': doubleQuotes && doubleQuotes.length ? doubleQuotes : addCase && addCase.length ? addCase : '',
        'anyOfSearch': OrCase

      }
      setAdvanceSearchData(searchText);
        setSearchQuery(searchText?.searchData);
      
    } else if (getQueryParam("q") || getQueryParam("epq") || getQueryParam("oq") || getQueryParam("eq")) {
      let searchString = '';
      if (getQueryParam("q")) {
        searchString = searchString + '' + getQueryParam("q");
      }
      if (getQueryParam("epq")) {
        searchString = searchString + ' ' + JSON.stringify(getQueryParam("epq"));
      }
      if (getQueryParam("oq")) {
        searchString = searchString + ' ' + getQueryParam("oq");
      }
      if (getQueryParam("eq")) {
        searchString = searchString + ' -' + getQueryParam("eq");
      }
      let searchData: any =
      {
        'searchData': getQueryParam('q') ? getQueryParam('q') : '',
        'exactSearch': getQueryParam('epq'),
        'notIncludeSearch': getQueryParam('oq'),
        'anyOfSearch': getQueryParam('eq'),
        'searchText': searchString
      };
      setAdvanceSearchData(searchData);
      if (searchData.searchData?.length) {
        setSearchQuery(searchData.searchData);
      }
    } else {
      setAdvanceSearchData({});
    }
    setFilters({});
    setExsistingfilters({})
    setSubjectText([]);
    setSelectedSortOption(SortByOption[0]);
    setSelectedSortOrder(ResearchListSortOrder.DESC)
    // setSubjectType('p');
    setPageNo(1);
    setSelectedTab(null);
    setTabClick('Search')
    setFilerPreSelection({});
    setPreviousSearchQuery(searchQuery)
  }, [queryParams]);

  useEffect(() => {
    if (searchQuery?.length || Object.keys(advanceSearchData)?.length || Object.keys(filerPreSelection)?.length) {
      postData(SEARCH_API_CONSTANTS.TAB_DATA,
        body,
        APIEnv.NODE_PREMIUM).then((res: any) => {
          if (res.ResponseType == "SUCCESS") {
            setShowTabList(res.data.tabList.length > 0);
          } else {
            setShowTabList(false);
          }
          setTabData(res);
        })
        .catch((err) => {
        });
    }
  }, [searchQuery, advanceSearchData, filerPreSelection]);

  useEffect(() => {
    if (pageNo == 1 && (searchQuery == previousSearchQuery) && tabClick == 'Search') {
      if (Object.keys(advanceSearchData)?.length) {
        getSearchResultData();
      }
    } else {
      getSearchResultData();
    }
  }, [pageNo, tabClick, searchQuery, advanceSearchData, selectedSortOption, selectedSortOrder]);

  useEffect(() => {
    if (filters && Object.keys(filters).length) {
      if (Object.keys(filerPreSelection)?.length) {
      } else {
        getSearchResultData()
      }
    }
  }, [filters]);

  useEffect(() => {
    if (subjectText && subjectText.length) {
      getSearchResultData()
    }else if(subjectReset){
      if (filters && Object.keys(filters).length && Object.values(filters).length && Object.values(filters).filter(function(e:any){return e.length}).length    ) {
        // not call reset subject if filters are present as api called on filters present, to stop multiple calls
        return;
      }
      getSearchResultData()
    }
    setSubjectReset(false);
  }, [subjectText, subjectType, subjectReset]);

  useEffect(() => {
    let preSelectedString = getDataFromLocalStorage(LocalStorageDataModel.HOMEPAGE_FILTER_SELECTION);
    if (preSelectedString?.length) {
      let preSelectedData = JSON.parse(preSelectedString);
      // if(getDataFromLocalStorage(LocalStorageDataModel.HOMEPAGE_FILTER_SELECTION)?.length){
      if (preSelectedData?.tabList?.name?.length) {
        setSelectedTab(preSelectedData?.tabList);
        setTabClick(preSelectedData?.tabList?.name)
        setFilerPreSelection(preSelectedData);
        // }
      } else {
        setFilerPreSelection({});
      }
    }
  }, [getDataFromLocalStorage(LocalStorageDataModel.HOMEPAGE_FILTER_SELECTION)]);


  function getSearchResultData() {
    window.scrollTo(0, 0)
    const logData = {
      componentURL: window.location.href,
      isGlobal: true,
      searchData: searchBody?.searchData,
    };
    
    searchLogData(logData,searchBody?.searchData)
    setLoading(true);
    setQuickInfo({});
    setSearchData({});
    let tempSearchData = searchBody['searchData'].trim();
    searchBody['searchData']=tempSearchData.slice(0,200);
    postData(SEARCH_API_CONSTANTS.SEARCH_RESULT,
      searchBody,
      APIEnv.NODE_PREMIUM).then((response => {
        setLoading(false);
        if (response?.ResponseType == APIStatus.SUCCESS) {
          setPlanData(response?.data)
          if(response?.StatusMsg== APIStatusError.PLAN_NOT_SUBSCRIBED||response?.StatusMsg== APIStatusError.PLAN_EXPIRED){
            setIsSubscribed(false);
            setSearchData(response?.data?.data);
          }
          else{
            setIsSubscribed(true);
            setSearchData(response?.data?.data);
            let items = response.data?.data?.itemarray || [];
            if (pageNo == 1) {
            const taxmannLearningItems = items.filter(
              (item: SearchItem) => item.Index === IndexName.learning
            );
            let newitems = items.filter(
              (item: SearchItem) => item.Index != IndexName.learning
            );
            const firstLearningIndex = items.findIndex(
              (item: SearchItem) => item.Index === IndexName.learning
            );
            if (taxmannLearningItems.length > 0 && firstLearningIndex !== -1) {
              newitems.splice(firstLearningIndex, 0, taxmannLearningItems);
            }
            let firstResult = (items[0].Index == IndexName.practice);
            if (firstResult) {
              getQuikInfoData(items[0])
            }
            setData(newitems);
            } else {
            setData(items);
            }
          } 
        }
      })
      ).catch(err => {
        setLoading(false);
      })
  }


  const onPageChange = (event: PaginatorPageChangeEvent) => {
    let pageNumber = event.page + 1;
    setFirst(event.first);
    setPageNo(pageNumber);
  };

  const onFilterFormDataChange = (formData: any) => {
    if (getDataFromLocalStorage(LocalStorageDataModel.HOMEPAGE_FILTER_SELECTION)?.length) {
      setDataOnLocalStorage(LocalStorageDataModel.HOMEPAGE_FILTER_SELECTION, JSON.stringify({}));
    }
    setFilters(formData);
    setExsistingfilters(formData);
  }

  function getQuikInfoData(item: any) {
    let params = {
      'topicid': item.Id
    }
    setQuickInfo({});
    getData(SEARCH_API_CONSTANTS.QUICK_INFO,
      params, '',
      APIEnv.TAX_PRACTICE).then((response: any) => {
        if (response?.ResponseType == APIStatus.SUCCESS) {
          if (response?.Data?.totalCount > 0) {
            if (response?.Data?.rows?.quickinfo?.length > 0) {
              let data = {
                searchedData: item,
                allInfo: response?.Data?.rows
              }
              setQuickInfo(data);
            }
          }
        }
      }
      ).catch(err => {
      })
  }

  const onSetSubjectFilter = (subjects: any) => {
    let subjectsFound = [...subjects];
    if (subjectsFound.length) {
      setSubjectText(subjectsFound)
    } else {
      setSubjectText([]);
      setSubjectReset(true);
    }
  }

  const onSetSubjectType = (subjecttype: string) => {
    if (!(subjecttype == subjectType)) {
      setSubjectType(subjecttype)
    }
  }

  const onClickSortOption = (sortOption: any) => {
    setSelectedSortOption(sortOption);
    if (sortOption.sortOrder == selectedSortOrder) { } else {
      setSelectedSortOrder(sortOption.sortOrder);
    }
  }


  const onClickSortOrder = (sortOrder: number) => {
    setSelectedSortOrder(sortOrder)
  }

  const navigateToSearchPage = (search: string) => {
    search = search.trim()
      ; navigate(`/search?searchData=${encodeURIComponent(search)}`);
  }

  const onClickShowHideFilter = () => {
    setShowFilter(!showFilter)
  }

  return (
    <>
      <div className="layout-container">
        <div className="pr-tabs-container">
          <div className="pr-tab-heads">
            <div className="max-container-ui2">
              {showTabList && 
              <ul className="pr-tab-items">

                <TabList
                  body={body}
                  tabClick={tabClick}
                  handleTabClick={handleTabClick}
                  handleSearchTabClick={handleSearchTabClick}
                  searchQuery={searchQuery}
                  tabData={tabData}
                  selectedTab={selectedTab}
                />
               <span className="m-none">  <Sortist  selectedTab={selectedTab} selectSortOption={selectedSortOption} selectSortOrder={selectedSortOrder} onClickSortOption={onClickSortOption} onClickSortOrder={onClickSortOrder} /> </span>
              </ul>
              }
            </div>
          </div>
          {/* mobile filter row */}
            {showTabList && 
          <div className="mob-head">
            <div className="mob-filter-row">
              <span className="mob-r-left sort-option-list">

                <Sortist selectedTab={selectedTab} selectSortOption={selectedSortOption} selectSortOrder={selectedSortOrder} onClickSortOption={onClickSortOption} onClickSortOrder={onClickSortOrder} />


              </span>
              <span className="mob-r-right">
                <span className="button-primary button-grey-u1" onClick={()=> onClickShowHideFilter()} >
                <span className={(Object.keys(filters).length > 0 && Object.values(filters).some(value => value && (Array.isArray(value) ? value.length > 0 : true))) || subjectText.length > 0 ? "selected-filter-sign ui-icon" : "ui-icon"}>
                <svg className="mr-2" width="22" height="17" viewBox="0 0 22 17" fill="black" stroke="black" xmlns="http://www.w3.org/2000/svg">
                    <path d="M7.56169 4.16829H20.4866C20.8323 4.16829 21.1254 3.87518 21.1254 3.52946C21.1254 3.18374 20.8323 2.89062 20.4866 2.89062H7.56169C7.21597 2.89062 6.92285 3.18374 6.92285 3.52946C6.92285 3.87517 7.21597 4.16829 7.56169 4.16829Z" fill="#110D3F" stroke="#110D3F" stroke-width="0.25" />
                    <path d="M1.51383 4.16829H3.52964C3.92117 4.16829 4.16848 3.86872 4.16848 3.52946C4.16848 3.18374 3.87536 2.89062 3.52964 2.89062H1.51383C1.16812 2.89062 0.875 3.18374 0.875 3.52946C0.875 3.87518 1.16812 4.16829 1.51383 4.16829Z" fill="#110D3F" stroke="#110D3F" stroke-width="0.25" />
                    <path d="M17.0871 9.02962H20.4863C20.832 9.02962 21.1251 8.7365 21.1251 8.39079C21.1251 8.04507 20.832 7.75195 20.4863 7.75195H17.0871C16.7414 7.75195 16.4482 8.04507 16.4482 8.39079C16.4482 8.7365 16.7414 9.02962 17.0871 9.02962Z" fill="#110D3F" stroke="#110D3F" stroke-width="0.25" />
                    <path d="M1.51383 9.02962H13.0553C13.4011 9.02962 13.6942 8.7365 13.6942 8.39079C13.6942 8.04507 13.4011 7.75195 13.0553 7.75195H1.51383C1.16812 7.75195 0.875 8.04507 0.875 8.39079C0.875 8.7365 1.16812 9.02962 1.51383 9.02962Z" fill="#110D3F" stroke="#110D3F" stroke-width="0.25" />
                    <path d="M7.56169 13.932H20.4866C20.8323 13.932 21.1254 13.6388 21.1254 13.2931C21.1254 12.9474 20.8323 12.6543 20.4866 12.6543H7.56169C7.21597 12.6543 6.92285 12.9474 6.92285 13.2931C6.92285 13.6388 7.21597 13.932 7.56169 13.932Z" fill="#110D3F" stroke="#110D3F" stroke-width="0.25" />
                    <path d="M1.51383 13.9315H3.52964C3.90925 13.9315 4.21357 13.6411 4.16843 13.2452C4.16403 12.903 3.87274 12.6143 3.52964 12.6143H1.51383C1.16215 12.6143 0.875 12.9135 0.875 13.2926C0.875 13.6383 1.16812 13.9315 1.51383 13.9315Z" fill="#110D3F" stroke="#110D3F" stroke-width="0.25" />
                    <path d="M2.89062 3.52964C2.89062 4.98208 4.09283 6.18429 5.54527 6.18429C7.0385 6.18429 8.19991 4.9808 8.19991 3.52964C8.19991 2.07721 6.9977 0.875 5.54527 0.875C4.09283 0.875 2.89062 2.07721 2.89062 3.52964ZM4.16829 3.52964C4.16829 2.76864 4.78427 2.15267 5.54527 2.15267C6.30627 2.15267 6.92225 2.76864 6.92225 3.52964C6.92225 4.29065 6.30627 4.90662 5.54527 4.90662C4.78427 4.90662 4.16829 4.29065 4.16829 3.52964Z" fill="#110D3F" stroke="#110D3F" stroke-width="0.25" />
                    <path d="M12.417 8.39097C12.417 9.84341 13.6192 11.0456 15.0716 11.0456C16.5649 11.0456 17.7263 9.84213 17.7263 8.39097C17.7263 6.93854 16.5241 5.73633 15.0716 5.73633C13.6192 5.73633 12.417 6.93854 12.417 8.39097ZM13.6947 8.39097C13.6947 7.62997 14.3106 7.014 15.0716 7.014C15.8326 7.014 16.4486 7.62997 16.4486 8.39097C16.4486 9.15198 15.8326 9.76795 15.0716 9.76795C14.3106 9.76795 13.6947 9.15198 13.6947 8.39097Z" fill="#110D3F" stroke="#110D3F" stroke-width="0.25" />
                    <path d="M2.89062 13.2923C2.89062 14.7448 4.09283 15.947 5.54527 15.947L8.07491 13.2923H8.19991C8.19991 13.2917 8.19991 13.2912 8.19991 13.2906C8.19893 11.8389 6.99711 10.6377 5.54527 10.6377C4.09411 10.6377 2.89062 11.7991 2.89062 13.2923ZM4.16829 13.2923C4.16829 12.5313 4.78427 11.9154 5.54527 11.9154C6.30627 11.9154 6.92225 12.5313 6.92225 13.2923C6.92225 14.0533 6.30627 14.6693 5.54527 14.6693C4.78427 14.6693 4.16829 14.0533 4.16829 13.2923Z" fill="#110D3F" stroke="#110D3F" stroke-width="0.25" />
                  </svg>
                  </span>
                  {
                    showFilter ? 
                    'Hide Filter'
                    :
                    'Show Filter'
                  }
                </span>
              </span>
            </div>
            {
              showFilter ? 
            <FilterList filterLists={searchData?.filter} onFilterFormDataChange={onFilterFormDataChange} exsistingfilters={exsistingfilters} tab={selectedTab}
              onSetSubjectFilter={onSetSubjectFilter} onSetSubjectType={onSetSubjectType} subjectText={subjectText} filerPreSelection={filerPreSelection} />
              :''
            }
          </div>
   }
          {/* end mobile filter row */}

          <div className="pr-tab-contents">
            <div className="pr-tab-content active">
              {/* AI chat section */}
              {/* ai chat */}
              <AIChat />

              {/* contents */}
              <div className="ui-layout">
                <div className="max-container-ui2">
                  <div className="ui-layout-head">
                    {
                      searchData?.didYouMean	 && searchData.didYouMean.trim().length>0?
                        <div className="search-mean-row">
                          <span className="title-mean-1">Did you mean : <a className="cursor-pointer"
                            onClick={() => navigateToSearchPage(searchData?.didYouMean)} > {searchData?.didYouMean}</a> </span>

                        </div>
                        : (
                          <>
                            {searchData?.searchInsteadfor	 && (
                              <div className="search-mean-row">
                                <span className="title-mean-1">
                                  No results found for: {searchData.searchInsteadfor}
                                </span>
                              </div>
                            )}
                        
                            {searchData?.showingResultsfor	 && (
                              <div className="search-mean-row">
                                <span className="title-mean-1">
                                  Showing results for:
                                  <a className="cursor-pointer" onClick={() => navigateToSearchPage(searchData.showingResultsfor	)}>
                                    {' '}{searchData.showingResultsfor	}
                                  </a>
                                </span>
                              </div>
                            )}
                          </>
                        )
                    }
                    <div>                      
                      {searchData?.totalCount ? (
                        <span className="ui-heading-s1">
                          {" "}
                          About {searchData?.totalCount} results found:{" "}
                        </span>
                      ) : (
                       <span className="ui-heading-s1">
                          {" "}
                          {searchData?.totalCount} results found:{" "}
                        </span>
                      )}
                    </div>
                  </div>
                  <div className="ui-layout-grid">
                    <div className="ui-layout-left">
                      {/* filter */}
                      <span className="m-none">
                        <FilterList filterLists={searchData?.filter} onFilterFormDataChange={onFilterFormDataChange} exsistingfilters={exsistingfilters} tab={selectedTab}
                          onSetSubjectFilter={onSetSubjectFilter} onSetSubjectType={onSetSubjectType} subjectText={subjectText} filerPreSelection={filerPreSelection} />
                      </span>
                      {/* data */}
                      
                      { loading && <SearchResultShimmer />}
                      { !loading && isSubscribed &&  (
                          searchData?.totalCount ?
                            <div>
                              {/* List 1 */}

                              <SearchResult result={data} searchQuery={searchQuery} searchString={advanceSearchData?.searchText}activeTab={tabClick} onViewAllClick={handleTabClick} quickInfo={quickInfo} />
                              {/* <span className="l-none"> <RightComponent info={quickInfo} /></span> */}
                              {
                                searchData?.totalCount > pageSize ?
                                  <Paginator first={first} rows={pageSize} totalRecords={searchData?.totalCount} onPageChange={onPageChange} />
                                  : ''
                              }

                            </div>
                            :
                            <NoResultFound searchQuery={searchQuery} searchString={advanceSearchData?.searchText} />
                        )
                      }
                      {
                        !loading && !isSubscribed && <SubscribeNow info={planData}/>
                      }
                    </div>
                   <span className="m-none"> <RightComponent info={quickInfo} /></span>
                  </div>
                </div>
              </div>

            </div>
          </div>
        </div>
      </div>
    </>
  );
};
